import { Navigate, Outlet } from "react-router-dom";

import useStateHandler from "@/hooks/useStateHandler";
import { canAccessGalleryPermission } from "@/utils/galleryPermissions";

export default function PostCreatorAccessRequired() {
  const { state } = useStateHandler();
  const me = state.user_session;
  const userType = String(me?.user_type ?? me?.__t ?? "").toLowerCase();
  const hasSuartePlus = Boolean(me?.suartePlus?.isActive);

  const isGalleryOrArtist = userType === "gallery" || userType === "artist";
  const isCollectorWithSuartePlus = userType === "collector" && hasSuartePlus;
  const hasGalleryPostAccess = canAccessGalleryPermission(me, "board.post", me?.gallery_id);

  if (isGalleryOrArtist || isCollectorWithSuartePlus || hasGalleryPostAccess) {
    return <Outlet />;
  }

  return <Navigate to="/" replace />;
}
